import Http from "../api/http";

export default class Taskpc extends Http {
  constructor() {
    super();
  }

  /**
   * @description: 查看任务详情
   * @param {type} 
   * taskId
   * @return: 
   */
  taskpc_getTaskInfo2cpc() {
    return super.post("taskpc/getTaskInfo2cpc", ...arguments);
  }
  taskpc_getTaskInfo() {
    return super.post("taskpc/getTaskInfo", ...arguments);
  }
  taskpc_getReportExampleByTaskId() {
    return super.post("taskpc/getReportExampleByTaskId", ...arguments);
  }

}